import { formatDecimal } from '@fluxus/shared';
import { cn } from '@/lib/cn';

/** Barra de progresso de 0 a 100% com o valor ao lado (acessível como progressbar). */
export function ProgressBar({
  value,
  label,
  className,
}: {
  value: number;
  label: string;
  className?: string;
}) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={value}
        aria-valuetext={`${formatDecimal(value)}%`}
        className="h-2 flex-1 overflow-hidden rounded-full bg-muted"
      >
        <div
          className="h-full rounded-full bg-brand"
          style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
        />
      </div>
      <span className="w-12 text-right text-xs font-semibold tabular-nums">{formatDecimal(value)}%</span>
    </div>
  );
}
